import type { SizeForm } from "@design-lab/shared/types";
import type { ArtworkDimensions } from "../types";

/**
 * Converts absolute size to scale based on max bounds
 */
export function calculateScaleFromSize(currentSize: SizeForm, bounds: ArtworkDimensions): number {
  if (bounds.maxWidthInches === 0 || bounds.maxHeightInches === 0) {
    return 1;
  }

  // Use width ratio as scale since aspect ratio is always maintained
  return Math.min(1, Math.max(0, currentSize.width / bounds.maxWidthInches));
}

/**
 * Applies stored scale to new bounds to get absolute size
 */
export function applyScale(scale: number, bounds: ArtworkDimensions): SizeForm {
  const proposedWidth = scale * bounds.maxWidthInches;
  const proposedHeight = scale * bounds.maxHeightInches;

  return {
    width: Math.max(bounds.minWidthInches, Math.min(proposedWidth, bounds.maxWidthInches)),
    height: Math.max(bounds.minHeightInches, Math.min(proposedHeight, bounds.maxHeightInches))
  };
}
